import { useParams, useNavigate } from "react-router-dom";

export function withNavigate(Component:any) {
    return (props:any) => (
        <Component {...props} params={useParams()} navigate={useNavigate()}  />
    );
}
